/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'Components/Button';
import Icon from 'Components/Icon';
import Input from 'Components/Input';
import CombinationFailMessage from './Partitions/CombinationFailMessage';
import EnvironmentManager from 'Utils/environmentManager';

class PlaySuccessModal extends Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  static propTypes = {
    onPrimaryButtonClick: PropTypes.func,
    onSecondaryButtonClick: PropTypes.func,
    couponDetails: PropTypes.array,
    playCouponState: PropTypes.object.isRequired
  }

  onChange = e => {
    this.setState({
      description: e.target.value
    });
  }

  getDescription = async () => {
    this.props.onPrimaryButtonClick(this.state.description);
  }

  onSecondaryButtonClick = async () => {
    this.props.onSecondaryButtonClick();
  }

  render () {
    const { couponDetails, onPrimaryButtonClick, playCouponState } = this.props;

    const { hasAnyOddOrLimitChanged } = playCouponState || {};

    const renderChangedEvents = (changeOddInfoList, couponDetails) => {
      const changedEventList = changeOddInfoList.map((oddInfo, index) => {

        const foundEvent = couponDetails?.find(detail => detail.eventId === oddInfo.eventId);

        const changedBetDetail = foundEvent ? foundEvent.bets?.find(bet => bet.id === `${oddInfo.eventId}:${oddInfo.marketId}:${oddInfo.marketOutcomeNo}`) : {};

        return (
          <div key={ index } className="play-coupon-success-modal__odd-changed-event">
            <div className="play-coupon-success-modal__odd-changed-event__title">

              <div className="play-coupon-success-modal__odd-changed-event__title__event-name">
                { `${foundEvent?.name}` }
              </div>
            </div>
            <div className="play-coupon-success-modal__odd-changed-event__changes">
              <div className="play-coupon-success-modal__odd-changed-event__changes__bet-type">
                { `${changedBetDetail.marketName} ${oddInfo.marketOutcomeNo}` } :
              </div>

              <div className="play-coupon-success-modal__odd-changed-event__changes__odds">
                <div className="play-coupon-success-modal__odd-changed-event__changes__odds__odd">
                  <div className="play-coupon-success-modal__odd-changed-event__changes__odds__odd__label">
                    Eski Oran:
                  </div>

                  <div className="play-coupon-success-modal__odd-changed-event__changes__odds__odd__value">
                    { oddInfo.previousOdd.toFixed(2) }
                  </div>
                  { oddInfo.increase
                    ? <Icon iconName="svgBetUp" className="play-coupon-success-modal__odd-changed-event__changes__odds__odd__icon" />
                    : <Icon iconName="svgBetDown" className="play-coupon-success-modal__odd-changed-event__changes__odds__odd__icon" /> }
                </div>

                <div className="play-coupon-success-modal__odd-changed-event__changes__odds__odd">
                  <div className="play-coupon-success-modal__odd-changed-event__changes__odds__odd__label">
                    Yeni Oran:
                  </div>
                  <div className="play-coupon-success-modal__odd-changed-event__changes__odds__odd__value">
                    { oddInfo.currentOdd.toFixed(2) }
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      });

      return changedEventList;
    };
    return (
      <div className="play-coupon-success-modal">
        <CombinationFailMessage data={ playCouponState } alignCenter />

        {
          hasAnyOddOrLimitChanged && couponDetails
          && <>
            <div className="play-coupon-success-modal__title">
              <Icon iconName="svgImportantBullhorn" />

              <div className="play-coupon-success-modal__title__text">
                Oran Değişikliği
              </div>
            </div>
            <div className="play-coupon-success-modal__description">
              <p> Oynadığın kuponda <strong>oran</strong> değişikliği gerçekleşen maçlar var.</p>
            </div>

            <div className="play-coupon-success-modal__odd-changed-events">
              { renderChangedEvents(playCouponState.changeOddInfoList, couponDetails) }
            </div>
          </>
        }

        { onPrimaryButtonClick
          && <>
            <Input
              name= { EnvironmentManager.getMessageText({ key: 'betslip_success_named_text' }) }
              id="description"
              autoComplete="off"
              autoFocus
              onChange={ this.onChange }
              maxLength={ 100 }
            />
            <Button title={ 'TRİBÜNDE PAYLAŞ' } className='btn--tribun btn--half-round' onClick={ this.getDescription }>
              <div className="play-coupon-success-modal__button-content">
                <Icon iconName="svgTribunWhite" className="tribün-icon-ios-fix" />
                <span>TRİBÜNDE PAYLAŞ</span>
              </div>
            </Button>
            <Button title={ 'TEKRAR OYNA' }  className='btn--primary btn--half-round' onClick={ this.onSecondaryButtonClick }>
              <span>{ EnvironmentManager.getMessageText({ key: 'success_popup_button_switch' }) === 'false' || !EnvironmentManager.getMessageText({ key: 'success_popup_button_switch' })  ? (EnvironmentManager.getMessageText({ key: 'button_play_again_uc' }) || 'TEKRAR OYNA') : (EnvironmentManager.getMessageText({ key: 'button_go_bulletin_uc' }) || 'BÜLTENE GİT') }</span>
            </Button>
          </>
        }

      </div>
    );
  }
}

export default PlaySuccessModal;
